<template>
    <div class="empty-state" :class="[{'empty-icon': emptyIcon, 'fullscreen': fullscreen, 'inline': inline, 'overlay': overlay, 'sm': small, 'xs': extraSmall}, 'align-' + align, 'icon-' + iconAlign]">

        <!-- Icon - MUST use a custom icon from the "icons" directory -->
        <component
                v-if="icon"
                class="icon-all-muted"
                :is="'icon-' + icon"
                :size="iconSize">
        </component>

        <!-- Animated Status Icons -->
        <component
                v-if="statusIcon"
                :is="'animated-' + statusIcon"
                :size="iconSize">
        </component>

        <!-- Font Awesome Icon -->
        <i
                v-if="faIcon"
                class="fal icon-all-muted"
                :class="'fa-' + faIcon">
        </i>

        <div>
            <!-- Title -->
            <h2 v-if="title" v-html="title"></h2>

            <!-- Subtitle -->
            <h3 v-if="subtitle" v-html="subtitle"></h3>
        </div>

        <!-- Content -->
        <p v-if="content" v-html="content"></p>

        <slot></slot>

    </div>
</template>

<script>
    export default {
        name: "EmptyState",

        props: {
            align: {
                type: String,
                default: "center"
            },
            content: {
                type: String,
                default: ""
            },
            emptyIcon: {
                type: Boolean,
                default: false
            },
            faIcon: {
                type: String,
                default: ""
            },
            fullscreen: {
                type: Boolean,
                default: false
            },
            icon: {
                type: String,
                default: ""
            },
            iconAlign: {
                type: String,
                default: "center"
            },
            iconSize: {
                type: String,
                default: "4x"
            },
            inline: {
                type: Boolean,
                default: false
            },
            overlay: {
                type: Boolean,
                default: false
            },
            small: {
                type: Boolean,
                default: false
            },
            statusIcon: {
                type: String,
                default: ""
            },
            subtitle: {
                type: String,
                default: ""
            },
            title: {
                type: String,
                default: "Nothing to See Here..."
            },
            extraSmall: {
                type: Boolean,
                default: false
            },
        }

    }
</script>